import React from "react";
import ProjectIcon from "assets/Icons/icons/ProjectIcon";
import { cloudCounterTabs } from "constant/cloud-counter";

const CountsMenu = ({ setActiveCountsTab, activeCountsTab }) => {
    return (
        <div className="p-4 w-full">
            <h1 className="text-[#454545] dark:text-white text-[18px] font-semibold leading-6">
                Site Counts
            </h1>
            <div className="mt-4 w-full space-y-1">
                {cloudCounterTabs.map((tab) => (
                    <div
                        key={tab.id}
                        onClick={() => setActiveCountsTab(tab.id)}
                        className={`flex gap-4 items-center px-4 py-3 cursor-pointer hover:bg-[#FCF2E8] hover:dark:bg-[#424E59] rounded-lg ${
                            activeCountsTab === tab.id
                                ? "bg-[#FCF2E8] dark:bg-[#424E59]"
                                : ""
                        }`}
                    >
                        <div className="p-1 bg-[#009BC0] rounded">
                            <ProjectIcon />
                        </div>
                        <p className="font-medium text-[15px] leading-5 text-[#454545] dark:text-white">
                            {tab.title}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CountsMenu;
